module.exports = __webpack_public_path__ + "img/exterior_12.fa1f8bfb.jpg";